import { render, staticRenderFns } from "./updatePoints.vue?vue&type=template&id=4d21f621"
import script from "./updatePoints.vue?vue&type=script&lang=js"
export * from "./updatePoints.vue?vue&type=script&lang=js"
import style0 from "./updatePoints.vue?vue&type=style&index=0&id=4d21f621&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports